define('meetings/launcher/embedded-launcher',['require','exports','module','durandal/app','knockout','web-urls','i18next','launch'],function (require, exports, module) {
    var app = require('durandal/app');
    var ko = require('knockout');
    var webUrls = require('web-urls');
    var i18n = require('i18next');
    var launch = require('launch');
    var launchModel = launch.model;

    function embeddedLauncher() {
        var self = this;
        self.launchHeadHtml = ko.observable('');
        self.launchMainHtml = ko.observable('');

        self.isModal = ko.computed(function () {
            // launcher team will consider abstracting this out in their own js lib
            var joinState = launchModel.joinState();
            var joinInstruction = launchModel.joinInstruction();
            return (joinState === 'ERROR' ||
                joinState === 'HOST_NOT_SUPPORTED' ||
                (!joinState &&
                (joinInstruction === 'LAUNCHING_APP' ||
                joinInstruction === 'TRY_LAUNCHING_APP' ||
                joinInstruction === 'LAUNCH_BY_CLICK' ||
                joinInstruction === 'CLICKONCE' ||
                joinInstruction === 'DOWNLOADING')));
            // ratelimit the events for consistent ui flows
        }).extend({rateLimit: {timeout: 500, method: 'notifyWhenChangesStop'}});

        self.isModal.subscribe(function (modal) {
            if (modal) {
                $('#launcher-modal').modal('show');
            } else {
                $('#launcher-modal').modal('hide');
            }
        });

        self.unintrusiveLaunchHead = ko.computed(function () {
            var modal = self.isModal();
            var html = launchModel.ui.head();
            return !modal && html;
        });

        self.modalLaunchHead = ko.computed(function () {
            var modal = self.isModal();
            var html = launchModel.ui.head();
            return modal && html;
        });

        self.modalLaunchMain = ko.computed(function () {
            var modal = self.isModal();
            var html = $.trim(launchModel.ui.main());
            return modal && html;
        });

        launch.ui.head.subscribe(function (html) {
            self.launchHeadHtml(html);
        });

        launch.ui.head.extend({rateLimit: {timeout: 500, method: 'notifyWhenChangesStop'}});

        launch.ui.main.subscribe(function (html) {
            self.launchMainHtml(html);
        });

        launch.ui.main.extend({rateLimit: {timeout: 500, method: 'notifyWhenChangesStop'}});

        launch.model.joinState.extend({rateLimit: {timeout: 500, method: 'notifyWhenChangesStop'}});

        self.connecting = ko.computed(function () {
            return launch.model.currentState().joinInstruction === 'LAUNCHED_APP' &&
                launch.model.joinState() !== 'SUCCESS';
        });

        self.connected = ko.computed(function () {
            return launch.model.joinState() === 'SUCCESS';
        });

        // Icons for the banner
        self.iconClasses = ko.computed(function () {
            return self.connecting() ?
              'togo-icon togo-icon-spinner fa-spin' :
              'togo-icon togo-icon-check';
        });

        var bannerOptions = {
            id: 'launch-status',
            classes: 'launcher-hooks alert-info',
            iconClasses: self.iconClasses,
            hideCloseIcon: true,
            message: self.launchHeadHtml,
            messageClasses: 'launch-head banner-launch-header'
        };

        self.unintrusiveLaunchHead.subscribe(function (unintrusiveLaunchHead) {
            if (unintrusiveLaunchHead) {
                app.trigger('banner:addOne', bannerOptions);
            } else {
                app.trigger('banner:remove', bannerOptions);
            }
        });

        launch.model.joinState.subscribe(function (state) {
            if (state === 'SUCCESS') {
                setTimeout(function () {
                    app.trigger('banner:remove', bannerOptions);
                    app.trigger('get:meetings');
                }, 10000);
            }
        });

        self.supportLink = function () {
            return i18n.t('launcher.support.message',
                '<a class="gcs-link"  href="' + i18n.t('web-urls.urls.g2m.support') + '">', '</a>');
        };

        self.stop = function () {
            launch.stop();
        };

        /*
         * Browser tries to load link tags before durandal' lifecycle completes and fails once
         * before retrying and succeeding hence load dynamic(environment specific) css from js itself.
         */
        var loadCss = function () {
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = self.launcherServiceUrl() + '/launcher2/static/styles/v2.css';
            document.getElementsByTagName('head')[0].appendChild(link);
        };

        self.activate = function () {
            self.launcherServiceUrl = ko.observable(webUrls.get('launcherSvcUrl'));
            loadCss();
            launch.model.product('g2m');
            launch.model.apiVersion(2);
            launch.model.host(self.launcherServiceUrl().split('https://').pop());
        };
    }

    module.exports = embeddedLauncher;
});

